// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-tagsinput-input {
  font-family: Source Sans Pro, Helvetica Neue, Helvetica, Arial, sans-serif;
}

.react-tagsinput.error {
  border: 1px solid #ff3232;
}

.tags-input-field__error-message {
  float: left;
  clear: both;
}

.TagsInputField .react-tagsinput--collapsed {
  max-height: 84px;
  overflow: auto;
}

.TagsInputField .react-tagsinput--limit-height {
  max-height: 84px;
}

.TagsInputField .react-tagsinput--disabled {
  background: #eee;
  border-color: #ccc;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/TagsInputField/TagsInputField.css","webpack://./services/frontend/app/components/TagsInputField/TagsInputField.css"],"names":[],"mappings":"AAAA;ECCE,0EAA0E;AAC5E;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["/* react-tagsinput style overrides */\n.react-tagsinput-input {\n  font-family: Source Sans Pro, \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n.react-tagsinput.error {\n  border: 1px solid #ff3232;\n}\n.tags-input-field__error-message {\n  float: left;\n  clear: both;\n}\n.TagsInputField .react-tagsinput--collapsed {\n  max-height: 84px;\n  overflow: auto;\n}\n.TagsInputField .react-tagsinput--limit-height {\n  max-height: 84px;\n}\n.TagsInputField .react-tagsinput--disabled {\n  background: #eee;\n  border-color: #ccc;\n}\n",".react-tagsinput-input {\n  font-family: Source Sans Pro, Helvetica Neue, Helvetica, Arial, sans-serif;\n}\n\n.react-tagsinput.error {\n  border: 1px solid #ff3232;\n}\n\n.tags-input-field__error-message {\n  float: left;\n  clear: both;\n}\n\n.TagsInputField .react-tagsinput--collapsed {\n  max-height: 84px;\n  overflow: auto;\n}\n\n.TagsInputField .react-tagsinput--limit-height {\n  max-height: 84px;\n}\n\n.TagsInputField .react-tagsinput--disabled {\n  background: #eee;\n  border-color: #ccc;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
